const OnboardingSteps = ({ stepIndex = 0 }) => {
  const steps = [
    { title: 'School & Department' },
    { title: 'Level & Matric' },
    { title: 'State & Review' }
  ]

  return (
    <ul className="steps w-full text-slate-700">
      {steps.map((s, idx) => {
        const state = idx < stepIndex ? 'step-success' : idx === stepIndex ? 'step-primary' : ''
        return (
          <li
            key={s.title}
            className={`step ${state}`}
            aria-current={idx === stepIndex ? 'step' : undefined}
          >
            <span className="text-xs sm:text-sm text-slate-700">{s.title}</span>
          </li>
        )
      })}
    </ul>
  )
}

export default OnboardingSteps

